import { render, staticRenderFns } from "./newBillOfLadingModal.vue?vue&type=template&id=68da867a&scoped=true"
import script from "./newBillOfLadingModal.vue?vue&type=script&lang=js"
export * from "./newBillOfLadingModal.vue?vue&type=script&lang=js"
import style0 from "./newBillOfLadingModal.vue?vue&type=style&index=0&id=68da867a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68da867a",
  null
  
)

export default component.exports